<template>
<div class="nkn-product">
  <div class="body-container">
    <div class="common-title">{{$t("home.nknProduct.title")}}</div>
    <div class="nkn-product-content">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-4">
          <div class="link-module">
            <ul>
              <li class="link-module-title">{{$t("home.nknProduct.flagshipProducts.title")}}</li>
              <li class="link-module-text">
                <a v-if="lang === 'zh'" :href="$url.PRODUCT_LINK.ncdn_zh" target="_blank">
                  <i class="icon-product-Telco"></i>
                  <span>{{$t("home.nknProduct.flagshipProducts.tab1")}}</span>
                </a>
                <a v-else :href="$url.PRODUCT_LINK.ncdn" target="_blank">
                  <i class="icon-product-Telco"></i>
                  <span>{{$t("home.nknProduct.flagshipProducts.tab1")}}</span>
                </a>
              </li>
              <li class="link-module-text">
                <a v-if="lang === 'zh'" href="https://forum.nkn.org/t/nkn-pub-sub/368" target="_blank" tag="a">
                  <i class="icon-product-Iot"></i>
                  <span>{{$t("home.nknProduct.flagshipProducts.tab2")}}</span>
                </a>
                <a v-else href="https://forum.nkn.org/t/introducing-decentralized-pub-sub-based-on-nkn/355" target="_blank" tag="a">
                  <i class="icon-product-Iot"></i>
                  <span>{{$t("home.nknProduct.flagshipProducts.tab2")}}</span>
                </a>
              </li>

            </ul>
          </div>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-4">
          <div class="link-module">
            <ul>
              <li class="link-module-title">{{$t("home.nknProduct.applications.title")}}</li>
              <li class="link-module-text">
                <a :href="$url.PRODUCT_LINK.dChat" target="_blank">
                  <i class="icon-product-dchat"></i>
                  <span>{{$t("home.nknProduct.applications.tab4")}}</span>
                </a>
              </li>

              <li class="link-module-text">
                <a v-if="this.$i18n.locale === 'zh'" :href="$url.PRODUCT_LINK.nsh_zh" target="_blank">
                  <i class="icon-product-nsh"></i>
                  <span>{{$t("home.nknProduct.applications.tab6")}}</span>
                </a>
                <a v-else :href="$url.PRODUCT_LINK.nsh" target="_blank">
                  <i class="icon-product-nsh"></i>
                  <span>{{$t("home.nknProduct.applications.tab6")}}</span>
                </a>
              </li>

              <li class="link-module-text">
                <a v-if="this.$i18n.locale === 'zh'" :href="$url.PRODUCT_LINK.dftp_zh" target="_blank">
                  <i class="icon-product-dftp"></i>
                  <span>{{$t("home.nknProduct.applications.tab7")}}</span>
                </a>
                <a v-else :href="$url.PRODUCT_LINK.dftp" target="_blank">
                  <i class="icon-product-dftp"></i>
                  <span>{{$t("home.nknProduct.applications.tab7")}}</span>
                </a>
              </li>

              <li class="link-module-text">
                <a :href="$url.PRODUCT_LINK.spacecats" target="_blank">
                  <i class="icon-product-spacecats"></i>
                  <span>{{$t('home.nknProduct.applications.tab1')}}</span>
                </a>
              </li>

              <li class="link-module-text">
                <a v-if="lang === 'zh'" href="https://forum.nkn.org/t/iotex-nkn/1586" target="_blank">
                  <i class="icon-product-iotex"></i>
                  <span>{{$t("home.nknProduct.applications.tab3")}}</span>
                </a>
                <a v-else :href="$url.PRODUCT_LINK.iot" target="_blank">
                  <i class="icon-product-iotex"></i>
                  <span>{{$t("home.nknProduct.applications.tab3")}}</span>
                </a>
              </li>

              <li class="link-module-text">
                <a v-if="lang === 'zh'" :href="$url.PRODUCT_LINK.tuna_ZH" target="_blank">
                  <i class="icon-product-testnet"></i>
                  <span>{{$t("home.nknProduct.applications.tab5")}}</span>
                </a>
                <a v-else :href="$url.PRODUCT_LINK.tuna" target="_blank">
                  <i class="icon-product-testnet"></i>
                  <span>{{$t("home.nknProduct.applications.tab5")}}</span>
                </a>
              </li>

            </ul>
          </div>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-4">
          <div class="link-module">
            <ul>
              <li class="link-module-title">{{$t("home.nknProduct.wallet.title")}}</li>
              <li class="link-module-text">
                <a :href="$url.PRODUCT_LINK.wallet" target="_blank">
                    <i class="icon-product-wallet"></i>
                    <span>{{$t("home.nknProduct.wallet.tab1")}}</span>
                  </a>
              </li>
             <!-- <li class="link-module-text">
                <a :href="$url.PRODUCT_LINK.newWallet" target="_blank">
                    <i class="icon-product-Newwallet"></i>
                    <span>{{$t("home.nknProduct.wallet.tab2")}}</span>
                  </a>
              </li>-->
              <!--<li class="link-module-text">
                <a :href="$url.PRODUCT_LINK.testnet" target="_blank">
                  <i class="icon-product-testnet"></i>
                  <span>{{$t("home.nknProduct.dashboard.tab1")}}</span>
                </a>
              </li>-->
              <li class="link-module-text">
                <a :href="$url.PRODUCT_LINK.nknx_explorer" target="_blank">
                  <i class="icon-product-nknx"></i>
                  <span>{{$t("home.nknProduct.dashboard.tab2")}}</span>
                </a>
              </li>
              <li class="link-module-text">
                <a :href="$url.PRODUCT_LINK.nknx" target="_blank">
                  <i class="icon-product-Newwallet"></i>
                  <span>{{$t("home.nknProduct.dashboard.tab4")}}</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
  import {mapState} from 'vuex'
export default {
  computed: {
    ...mapState({
      lang: state=>state.lang.lang
    })
  },
}
</script>

<style lang="scss" scoped>
.nkn-product {
  padding: 4rem 0;
  @media screen and (max-width:768px){
    padding: 0;
  }
  &-content {
    margin-top: 4rem;
    margin-left: 2rem;

    @media screen and (max-width: 992px) {
      margin-left: 10rem;
    }
    @media screen and (max-width: 900px) {
      margin-left: 8rem;
    }
    @media screen and (max-width: 800px) {
      margin-left: 6rem;
    }
    @media screen and (max-width: 768px) {
      margin: 0;
      .row{
        width: 60%;margin-left: auto !important;margin-right: auto !important;
      }
    }
    @media screen and (max-width: 550px) {
      .row{
        width: 100%;margin-left: auto !important;margin-right: auto !important;
      }
    }

    .link-module {
      margin-bottom: 3rem;
      ul{
        padding-left:  1rem;
        padding-right:  1rem;
      }
      @media screen and (max-width: 768px) {
        margin-left: 1rem;
      }

      &-title {
        @include nkn-font-set(1.2rem, currentColor);
        line-height: 1.2rem;

        @media screen and (max-width: 768px) {
          margin-top: 2rem;
        }
      }

      &-text {
        @include nkn-font-set(.7rem, currentColor);
        line-height: 1rem;
        margin-top: 1rem;
        min-height: 2.25rem;

        // @media screen and (max-width: 768px) {
        //   display: inline-block;
        // }

        i {
          flex-shrink: 0;
          vertical-align: middle;
        }

        span {
          display: inline-block;
          padding-top: .25rem;
          margin-left: .5rem;

          @media screen and (max-width: 768px) {

          }
        }

        &>a {
          display: flex; align-items: center;

          &:hover {
            color: #1791f2 !important;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/nknApplication.vue